export class ListAzureDiskEncryptionSetsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureDiskEncryptionSetsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
